module.exports = __webpack_public_path__ + "img/bell-regular.e375f04a.svg";